<template>
  <div>
    <v-card class="survey-header-card">
      <div class="survey-title">{{ survey.title }}</div>
      <div class="survey-question-block">
        <span class="survey-label">{{ $t("communication.survey.question") }}</span>
        <div class="survey-question-text" v-html="questionHtml"></div>
      </div>
      <div class="survey-meta">
        <div class="meta-item">
          <span class="survey-label">{{ $t("communication.survey.startDate") }}</span>
          <span class="meta-value">{{
            moment(survey.created_at).format("DD-MM-YYYY HH:mm")
          }}</span>
        </div>
        <div class="meta-item">
          <span class="survey-label">{{ $t("communication.survey.endDate") }}</span>
          <span class="meta-value">{{
            moment(survey.end_date).format("DD-MM-YYYY HH:mm")
          }}</span>
        </div>
        <div class="meta-item">
          <span class="survey-label">{{ $t("communication.survey.driverType") }}</span>
          <span class="meta-value">{{ survey.driver_type }}</span>
        </div>
        <div class="meta-item">
          <span class="survey-label">{{ $t("communication.survey.driversAnswered") }}</span>
          <span class="meta-value">{{ answersCount }}</span>
        </div>
      </div>
    </v-card>

    <v-tabs v-model="active" color="#FAFAFA" slider-color="primary" fixed-tabs>
      <v-tab active-class="tab" :key="2" ripple> {{ $t("communication.survey.surveyOptions") }} </v-tab>

      <v-tab-item>
        <v-layout align-start>
          <v-flex xs12>
            <div class="options">
              <div v-for="(op, index) in survey_options" :key="index" class="option">
                <div class="title">
                  <span class="count">{{ index + 1 }}</span>
                  <span class="option-name">{{ op.option }}</span>
                </div>
                <div class="percentage">
                  {{ $t("communication.survey.percentage") }}
                  {{ parseFloat((op.count / answersCount) * 100).toFixed(2) }}
                  <span class="symbol">%</span>
                </div>
                <div class="percentage">
                  {{ $t("communication.survey.count", { count: op.count }) }} <span class="symbol"></span>
                </div>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-tab-item>

      <v-tab active-class="tab" :key="3" ripple> {{ $t("communication.survey.surveyAnswers") }} </v-tab>

      <v-tab-item>
        <v-data-table :headers="headers" :items="survey_answers" :loading="loading">
          <template v-slot:items="props">
            <td class="text-xs-left">{{ props.item.captain.username }}</td>
            <td class="text-xs-left">
              {{ `${props.item.captain.first_name} ${props.item.captain.last_name}` }}
            </td>
            <td class="text-xs-left">{{ props.item.option.option }}</td>
            <td class="text-xs-left">
              {{ moment(props.item.created_at).format("DD-MM-YYYY HH:mm") }}
            </td>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import LoadingComponent from "@/components/LoadingComponent";
import MonthlyBookingsChart from "@/components/profile/captain/MonthlyBookingsChart";
import TimelineComponent from "@/components/Timeline.vue";

export default {
  name: "survey",
  title() {
    return this.$t("communication.survey.title");
  },
  components: {
    LoadingComponent,
    DataTable,
    MonthlyBookingsChart,
    TimelineComponent,
  },

  data() {
    return {
      log: "",
      active_el: 0,
      //survey
      survey: "",
      percentage: [],
      driversCount: 0,
      answersCount: 0,
      survey_options: [],
      survey_answers: [],
      loading: false,
      pagination: {
        sortBy: "id",
        rowsPerPage: 100,
      },

      uploading: false,
      carLoading: false,
      dialog: false,
      formatters: {
        notes: {
          author(value) {
            return `${value.first_name} ${value.last_name} (${value.username})`;
          },
          expiry_date(value) {
            if (!value) return "For Ever";
            return new Date(value).toLocaleDateString();
          },
          created_at(value) {
            return new Date(value).toLocaleString();
          },
        },
        logs: {
          created_at(value) {
            return new Date(value).toLocaleString();
          },
        },
      },
    };
  },
  created() {
    this.axios.get(`survey/${this.$route.params.id}`).then(({ data }) => {
      this.answersCount = data.data.answers.length;
      this.survey = data.data;
      this.survey_options = data.data.options;
      this.survey_answers = data.data.answers;
      this.survey_options.map((survey_option, index) => {
        survey_option.count = 0;
        return this.survey_answers.map((survey_answer, index) => {
          if (survey_answer.option_id == survey_option.id)
            return (survey_option.count += 1);
        });
      });
    });
    // this.axios.get(`captain`).then(({ data }) => {
    //   this.driversCount = data.data.total;
    // });
  },
  mounted() {},
  watch: {
    pagination: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },
  methods: {},
  computed: {
    headers() {
      return [
        { text: this.$t("communication.survey.captainUsername"), value: "captain_id" },
        { text: this.$t("communication.survey.captainName"), value: "captain_id" },
        { text: this.$t("communication.survey.answer"), value: "option_id" },
        { text: this.$t("communication.survey.answeredAt"), value: "created_at" },
      ];
    },
    questionHtml() {
      return (this.survey.question || "").replace(/\n/g, "<br/>");
    },
  },

  formatter() {},
};
</script>

<style lang="scss" scoped>
.survey-header-card {
  padding: 24px 28px;
  border-radius: 12px;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08);
  background: #edf1f3;
}
.survey-title {
  font-size: 22pt;
  font-weight: 700;
  color: #202731;
}
.survey-label {
  display: block;
  font-size: 9pt;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #788e98;
}
.survey-question-block {
  margin-top: 14px;
}
.survey-question-text {
  margin-top: 4px;
  font-size: 12pt;
  color: #202731;
  line-height: 1.5;
}
.survey-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 28px;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #ced3d4;

  .meta-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .meta-value {
    font-size: 11pt;
    font-weight: 600;
    color: #202731;
  }
}
.body {
  background-color: #ffffff !important;
}
.docs:hover {
  cursor: pointer;
}
.star {
  color: #f3c220;
}
.image {
  border-radius: 100%;
  height: 100px;
  width: 100px;
  margin-right: 17px;
  margin-top: 10px;
}
.image:hover {
  background-color: black;
  opacity: 0.5;
  border-radius: 100%;
  cursor: pointer;
}
.tab {
  color: #e21024 !important;
}
.active {
  border-style: solid;
  border-color: #e42235;
  border-width: thin;
}

.captains-list {
  width: 100%;
  margin-left: 90px;
  z-index: 7;
  max-height: 100px;
  min-height: 100px;
  float: left;
  padding: 22px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #ededed;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #788e98;
  }
}

.captain {
  width: max-content;
  float: left;
  font-size: 12pt;
  font-weight: normal !important;
  padding: 12px;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 6px;
  cursor: pointer;

  img {
    height: 32px;
    width: 32px;
    float: left;
    border-radius: 100%;
  }

  .name {
    color: #202731;
    width: max-content;
    overflow: hidden;
    min-width: 140px;
    max-width: 250px;
  }
}

.car {
  color: #7e939c;
}
.open {
  margin-bottom: 15px;
  margin-left: 35px;
}
.constraints.v-label {
  font-size: xx-large !important;
}

.info-table {
  border-collapse: collapse;
  width: 100%;
}

.info-table td:not(:first-child) {
  padding: 12px;
}

.options {
  width: 100%;
  float: left;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 2.5em;
  gap: 16px;
  .option {
    float: left;
    border: 1px solid #788e98;
    border-radius: 12px;
    overflow: hidden;
    min-width: 120px;
    .title {
      width: 100%;
      background: #ced3d4;
      padding: 12px 18px;
      float: left;
      color: #202731;
      font-size: 12pt !important;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 6px;

      .count {
        color: rgb(197, 203, 204);
        font-size: 8pt;
        padding: 4px;
        border-radius: 4px;
        background: rgb(97, 127, 133);
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 85%;
        min-width: 24px;
        height: 24px;
      }
    }
    .percentage {
      width: 100%;
      padding: 12px;
      font-size: 18pt;
      color: #202731;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-weight: 700;

      .symbol {
        color: #788e98;
        font-size: 12pt;
        font-weight: 400;
        margin-left: 4px;
      }
    }
  }
}
</style>
